import phone from 'phone';
import { PHONE_MASKS, MAP_PHONES } from '@constants/phone';

export const formatPhoneNumber = number => {
    const { isValid, countryIso2, countryCode, phoneNumber } = phone(number, {
        country: null,
        validateMobilePrefix: false,
    });
    if (!isValid) return number;
    const mask = PHONE_MASKS[countryIso2];

    const numberPart = phoneNumber.slice(countryCode.length);
    let formattedNumber = '';
    let maskIndex = 0;

    for (let i = 0; i < mask.length; i++) {
        if (mask[i] === '.') {
            formattedNumber += numberPart[maskIndex++] || '';
        } else if (mask[i] === ' ') {
            formattedNumber += mask[i];
        } else if (mask[i] === '(' || mask[i] === ')' || mask[i] === '-') {
            formattedNumber += mask[i];
        }
    }
    return `${countryCode} ${formattedNumber}`;
};

export const setInitialPhoneNumberToForm = (phoneNumber, locale) => {
    const countryCode = MAP_PHONES[locale];
    if (!phoneNumber) return countryCode;
    const formattedNumber = phoneNumber?.startsWith('+') ? phoneNumber?.slice(1) : phoneNumber;
    return formattedNumber || countryCode;
};

const OPTIONAL_PHONE_MIN_LENGTH = 4;

export const preparePhoneNumberForSubmit = (phoneNumber, isOptional = false) => {
    if (!isOptional) return `+${phoneNumber}`;
    return phoneNumber.length > OPTIONAL_PHONE_MIN_LENGTH
        ? phoneNumber?.startsWith('+')
            ? phoneNumber
            : `+${phoneNumber}`
        : '';
};

export const isPersistedPhoneInput = value => typeof value === 'string' && value.length > OPTIONAL_PHONE_MIN_LENGTH;

export const phoneDigits = phoneNumber => (phoneNumber || '').replace(/\D/g, '');

export const isInvalidPhone = phone => {
    const digits = phone.replace(/\D/g, '');
    return digits.length < 7 || digits.length > 15;
};

export const hasInvalidNewPhone = (phones, storedPhones = []) =>
    (phones ?? []).some(phone => !!phone?.trim() && !storedPhones.includes(phone) && isInvalidPhone(phone));
